export class guard {
  static fromNull(obj: any, name: string) {
    if (obj === null || obj === undefined) throw `${name} is required`;
  }
  static fromEmpty(arr: Array<any>, name: string) {
    guard.fromNull(arr, name);
    if (arr.length === 0) throw `${name} must not be empty`;
  }
}
